import { DataSourceSummary } from "../api/models/DataSource";
import ConnectionTypeChips from "./ConnectionTypeChips";
import Table from "./Table";
import { formatNumber } from "../utils/formatNumber";
import { isDefined } from "../utils/isDefined";
import Chip from "./Chip";

export type DataSourceTableProps = {
    onRowClick: (id: number) => void;
    dataSources: DataSourceSummary[];
    orderBy?: string;
    onOrderBy: (orderBy: string) => void;
    sortOrder?: string;
};

const DataSourcesTable = ({
    onRowClick,
    dataSources,
    orderBy,
    sortOrder,
    onOrderBy,
}: DataSourceTableProps) => {
    return (
        <Table
            className="!min-w-[1200px]"
            headings={[
                {
                    label: "Unique Reference",
                    orderByKey: "UniqueReference",
                },
                { label: "Name", orderByKey: "Name" },
                { label: "Location", orderByKey: "LocationName" },
                { label: "Scope", orderByKey: "Scope" },
                { label: "Reported Units" },
                { label: "Emissions Factor" },
                { label: "Connection Type" },
            ]}
            data={dataSources}
            renderRowCells={(rowData) => (
                <>
                    <td className="!min-w-[110px]">
                        {rowData.uniqueReference}
                    </td>
                    <td className="!max-w-[200px]">{rowData.name}</td>
                    <td className="!max-w-[200px]">{rowData.locationName}</td>
                    <td className="min-w-[60px]">{rowData.scope}</td>
                    <td className="min-w-[100px]">
                        <span
                            dangerouslySetInnerHTML={{
                                __html: rowData.rawUnitsSuffixHtml,
                            }}
                        />
                    </td>
                    <td className="min-w-[100px]">
                        {isDefined(rowData.currentEmissionsFactor) ? (
                            formatNumber(rowData.currentEmissionsFactor)
                        ) : (
                            <Chip colour="red">
                                Missing
                            </Chip>
                        )}
                    </td>
                    <td className="min-w-[120px]">
                        <div className="flex flex-wrap gap-2">
                            <ConnectionTypeChips {...rowData} />
                        </div>
                    </td>
                </>
            )}
            onRowClick={(rowData) => onRowClick(rowData.id)}
            orderBy={orderBy}
            sortOrder={sortOrder}
            onOrderBy={onOrderBy}
        />
    );
};

export default DataSourcesTable;
